<template>
  <v-bottom-sheet
    v-model="scopesDialog"
    :fullscreen="fullscreen"
    scrollable
    :no-click-animation="true"
    @click:outside="closeSheet"
  >
    <v-sheet :height="bottomsheetSize" style="display:flex;flex-direction:column">

      <div class="ec-list" style="flex:1;overflow:hidden;display:flex;flex-direction:column;border-radius:0">

        <admin-table-subheader
          v-model="search"
          title="Licence Scopes"
          search
          search-placeholder="Search scope…"
          :refresh-button="true"
          :icon-buttons="[
            { icon: fullscreen ? 'mdi-window-restore' : 'mdi-checkbox-blank-outline', title: fullscreen ? 'Restore' : 'Fullscreen', click: () => fullscreen = !fullscreen }
          ]"
          :primary-button="{ label: 'New Scope', icon: 'mdi-plus', click: newScopeDialog }"
          :close-button="true"
          @refresh="fetchScopes"
          @close="closeSheet"
        />

        <div v-if="loadingScopes" class="ec-loading">
          <v-progress-circular indeterminate color="primary" size="32" />
        </div>

        <v-data-table
          v-else
          :headers="headers"
          :items="getLicenceScopes"
          :search="search"
          class="ec-table"
          style="flex:1;overflow:auto"
        >
          <template v-slot:[`item.scope`]="{ item }">
            <code class="ls-scope-code">{{ item.scope }}</code>
          </template>

          <template v-slot:[`item.subScope`]="{ item }">
            <span v-if="Object.keys(item.sub_scope).length > 0" style="display:flex;flex-wrap:wrap;gap:4px">
              <span v-for="k in Object.keys(item.sub_scope)" :key="k" class="ec-badge ec-badge--gray" style="font-size:.68rem">{{ k }}</span>
            </span>
            <span v-else class="u-status-pill u-pill--gray">None</span>
          </template>

          <template v-slot:[`item.is_active`]="{ item }">
            <span class="u-status-pill" :class="item.is_active ? 'u-pill--green' : 'u-pill--red'">
              <v-icon size="11" style="margin-right:3px">{{ item.is_active ? 'mdi-check' : 'mdi-close' }}</v-icon>
              {{ item.is_active ? 'Active' : 'Inactive' }}
            </span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-menu offset-y content-class="ec-action-menu">
              <template v-slot:activator="{ on }">
                <button class="ec-icon-btn" v-on="on">
                  <v-icon size="16">mdi-dots-horizontal</v-icon>
                </button>
              </template>
              <v-list>
                <v-list-item
                  v-for="(action, idx) in actionButtons"
                  :key="idx"
                  :disabled="action.disabled"
                  @click="action.func(item)"
                >
                  <v-list-item-icon class="mr-2">
                    <v-icon :color="action.color" size="16">{{ action.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="ec-menu-item" :class="action.color === 'red' ? 'ec-menu-item--danger' : ''">
                      {{ action.actionName }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </div>

      <new-scope
        v-if="newScopeDailog"
        :showNewScopeDialog="newScopeDailog"
        @closeNewScopeDialog="newScopeDailog = false"
      />
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import { apiService } from '../../service/api.service'
import NewScope from './NewScope.vue'
import AdminTableSubheader from '../shared/AdminTableSubheader.vue'

export default {
  components: { NewScope, AdminTableSubheader },
  props: {
    scopesDialog: { type: Boolean, default: true }
  },
  data () {
    return {
      search: '',
      fullscreen: false,
      newScopeDailog: false,
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Scope', value: 'scope' },
        { text: 'Status', value: 'is_active' },
        { text: 'Description', value: 'description' },
        { text: 'Sub Scope', value: 'subScope' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      actionButtons: [
        { icon: 'mdi-pencil-circle-outline', actionName: 'Edit Scope', color: 'grey', func: this.editScope, disabled: true },
        { icon: 'mdi-delete-outline', actionName: 'Delete Scope', color: 'red', func: this.deleteScope, disabled: false }
      ]
    }
  },
  computed: {
    ...mapGetters(['getLicenceScopes', 'loadingScopes']),
    bottomsheetSize () {
      switch (this.$vuetify.breakpoint.name) {
        case 'lg': return '70vh'
        case 'xl': return '50vh'
        default: return '100vh'
      }
    }
  },
  methods: {
    newScopeDialog () { this.newScopeDailog = true },
    async fetchScopes () { await this.$store.dispatch('getLicenceScopes') },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    editScope () {},
    deleteScope (item) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'Do you want to delete this scope?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete'
      }).then(async (res) => {
        if (res.value) {
          await apiService.delete(`admin/scope/${item.id}`)
            .then(() => { this.fetchScopes(); Swal.fire('Deleted!', 'Scope has been deleted.', 'success') })
            .catch(() => Swal.fire('Failed', 'Failed to delete scope, please try again', 'warning'))
        }
      })
    },
    closeSheet () { this.$emit('closeSheet') }
  }
}
</script>

<style scoped>
.ls-scope-code {
  font-size: .8rem;
  font-weight: 700;
  color: var(--ec-primary);
  background: var(--ec-primary-bg);
  padding: 2px 7px;
  border-radius: 4px;
}
</style>
